var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompassHeading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 109.8 112.5",
    style: {
      enableBackground: "new 0 0 109.8 112.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "compass_00000035505240606323636040000001454710560604993458_",
    d: "M54.6,109.3C24.5,109.3,0.2,85,0.2,55 c0-30.2,24.3-54.6,54.4-54.6s54.4,24.3,54.4,54.4C109.1,85,84.6,109.3,54.6,109.3z M54.6,101.6c25.6,0,46.6-21,46.6-46.6 S80.2,8.4,54.6,8.4S8,29.3,8,55S29.1,101.6,54.6,101.6z M54.6,60.3c3,0,5.5-2.5,5.5-5.5s-2.5-5.5-5.5-5.5c-3,0-5.5,2.5-5.5,5.5 C49.2,57.8,51.7,60.3,54.6,60.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Needle",
    style: {
      transformBox: "fill-box",
      transformOrigin: "center center",
      transform: "rotate(0deg)"
    },
    fill: "currentColor",
    d: "M53.1,96.2c-0.6,0.4-1.4,0.7-2.2,0.5c-1.5-0.2-2.6-1.2-3-2.6l-9.5-39.7c-0.2-0.6-0.1-1.3,0.1-1.9l12.8-37.3 c0.4-1.4,1.7-2.3,3.1-2.2c1.4,0,2.7,1,3.1,2.3l13.1,39.4c0.3,0.7,0.2,1.7-0.1,2.3L54.3,94.5C54,95.4,53.6,95.9,53.1,96.2z  M45.1,53.9l7,29L64,55.6l-9.6-28.7L45.1,53.9z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassHeading);
export default __webpack_public_path__ + "static/media/compass-heading.8d07c89686ac7a2354068ab930abc5b5.svg";
export { ForwardRef as ReactComponent };